/**
=========================================================
* Soft UI Dashboard React — line chart area fill (semi-transparent gradient).
=========================================================
*/

import rgba from "assets/theme/functions/rgba";

/**
 * Vertical gradient under the line: strong near the line, fading to transparent.
 * @param {HTMLCanvasElement} chart - Canvas element from Chart.js
 * @param {string} color - Line color (hex)
 * @param {number} opacity - Peak opacity under the curve (e.g. 0.15–0.35)
 */
function gradientChartLine(chart, color, opacity = 0.22) {
  const peak = rgba(color, opacity);
  const mid = rgba(color, opacity * 0.58);
  const transparent = rgba(color, 0);

  if (!chart || typeof chart.getContext !== "function") {
    return peak;
  }

  const ctx = chart.getContext("2d");
  const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
  gradientStroke.addColorStop(1, peak);
  gradientStroke.addColorStop(0.45, mid);
  gradientStroke.addColorStop(0, transparent);
  return gradientStroke;
}

export default gradientChartLine;
